import { useFormik } from 'formik';
import { Button, Form, FormGroup, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { InputField } from 'src/components';
import * as Yup from 'yup';

interface Props {
  isOpen: boolean;
  toggle: any;
  infoId: any;
  getAllowanceApproval: any;
  sessionInfo?: any
}
const initialValues = {
  id: '',
  status: 'Approve',
  note: '',
};

const ApprovalModal = (props: Props) => {

  const { isOpen, toggle, infoId, getAllowanceApproval, sessionInfo } = props;

  const {
    values,
    handleSubmit,
    resetForm,
    setFieldValue,
    handleChange,
    getFieldProps,
    touched,
    errors,
  } = useFormik({
    initialValues,
    validationSchema: Yup.object({
      note: Yup.string().when('status', (status, schema) => {
        if (status === 'Correction' || status === 'Reject') {
          return schema.required('Note is Required!');
        }
        return schema;
      }),
    }),
    onSubmit: (values) => {
      const approveUrl = `${infoId}/${values.status}?note=${values.note}&session_name=${sessionInfo.session_name}&session_year=${sessionInfo.session_year}`;
      getAllowanceApproval(approveUrl);
    },
  });


  return (
    <Modal
      isOpen={isOpen}
      backdrop={'static'}
      toggle={toggle}
      size="md"
    >
      <ModalHeader toggle={toggle}>Approval Status</ModalHeader>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(e);
        }}
      >
        <ModalBody>
          <div className="col">
            <FormGroup check inline className="mb-3 ms-2">
              <input
                className="form-check-input"
                type="radio"
                name="status"
                id="Approve"
                onChange={(e) => {
                  setFieldValue('status', 'Approve');
                }}
                checked={values.status === 'Approve'}
              />
              <label
                className="form-check-label text-success"
                htmlFor="Approve"
              >
                Eligible
              </label>
            </FormGroup>
            <FormGroup check inline className="mb-3 ">
              <input
                className="form-check-input"
                type="radio"
                name="status"
                id="Reject"
                onChange={() => {
                  setFieldValue('status', 'Reject');
                }}
              />
              <label
                className="form-check-label text-danger"
                htmlFor="Reject"
              >
                Not Eligible
              </label>
            </FormGroup>
            <FormGroup check inline className="mb-3 ">
              <input
                className="form-check-input"
                type="radio"
                name="status"
                id="Correction"
                onChange={() => {
                  setFieldValue('status', 'Correction');
                }}
              />
              <label
                className="form-check-label text-warning"
                htmlFor="Correction"
              >
                Correction
              </label>
            </FormGroup>
          </div>
          {(values.status === 'Correction' || values.status === 'Reject') ?
            <div>
              <label className="form-label required-field">Note</label>
              <InputField
                type="text"
                placeholder="Enter Note"
                {...getFieldProps('note')}
                invalid={{ errors, touched }}
              />
            </div> : null}
        </ModalBody>
        <ModalFooter>
          <div className="d-flex gap-1">
            <button
              type="submit"
              className="btn btn-primary"
            >
              Save
            </button>

            <Button color="danger" onClick={toggle}>
              Close
            </Button>
          </div>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default ApprovalModal;
